import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Button, Layout, Drawer, Modal } from 'antd';
import { ManageSubsNavigation, ManageSubsNavigationMobile } from './';
import { ErrorPage } from '../common';
import { AUTH_ERROR_MSG } from '../../common/constants';
import { redirectUrl } from '../../common/apiConfig';
import { useResponsive } from './useResponsive';
import SyscoTruck from '../../assets/SYSCO_TRUCK.svg';

export default function ManageSubs({ children }) {
  const [collapse, setCollapse] = useState(false);
  const [isLandscape, setIsLandscape] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const { isMobile } = useResponsive(600, 450); 
    const {
    fetchSubstitutionsDataError,
    fetchValidationItemDataError,
    fetchConceptDataError,
    fetchValidationCustomerDataError,
    updateSubstitutionsDataError,
    fetchAddedSubsDataError,
    fetchAccountDataError,
    updateAccountDataError,
    deleteAccountDataError,
    fetchOutsDataError,
    fetchOrderDetailDataError,
    fetchInventoryDataError,
    checkAccountIfExistError,
    fetchRecommendedProductsError,
    searchSubstituteProductsError,
    removeDropOutsError,
    removeAllocatedItemError,
    checkOutsLockError,
    updateOutsRecordLockError,
    deleteManageSubsError,
    fetchTerritoryDataError,
    fetchSearchPanelOrgInfoError,
    fetchDropoutsDataError,
    updateEidtSubsLockError,
    updateEditAccountLockError,
    validateItemInChargeError,
    checkEditAccountLockError,
    checkEditSubsLockError,
    allocateOriginalItemError,
    fetchCustomerGroupDataError,
    fetchValidateGroupError,
    fetchGroupIdsDataError,
    fetchCustomerDataError,
    removeCustomerError,
    updateCustomerGroupError,
    addCustomersError,
    fetchDropOutsReasonError,
    removeCustomersError,
    fetchSubsAuditTrailDataError,
    fetchAccountsAuditTrailDataError,
    exportManageAccountAuditTrailError,
    exportSubsAuditTrailError,
    fetchGroupsAuditTrailDataError,
    fetchConceptIdsDataError,
    exportGroupsAuditTrailError,
    getSubstitutionsDataError,
    fetchOgmSubsDataError,
  } = useSelector(state => ({
    fetchSubstitutionsDataError: state.manageSubs.fetchSubstitutionsDataError,
    fetchValidationItemDataError: state.manageSubs.fetchValidationItemDataError,
    fetchConceptDataError: state.manageSubs.fetchConceptDataError,
    fetchValidationCustomerDataError: state.manageSubs.fetchValidationCustomerDataError,
    updateSubstitutionsDataError: state.manageSubs.updateSubstitutionsDataError,
    fetchAddedSubsDataError: state.manageSubs.fetchAddedSubsDataError,
    fetchAccountDataError: state.manageSubs.fetchAccountDataError,
    updateAccountDataError: state.manageSubs.updateAccountDataError,
    deleteAccountDataError: state.manageSubs.deleteAccountDataError,
    fetchOutsDataError: state.manageSubs.fetchOutsDataError,
    fetchOrderDetailDataError: state.manageSubs.fetchOrderDetailDataError,
    fetchInventoryDataError: state.manageSubs.fetchInventoryDataError,
    checkAccountIfExistError: state.manageSubs.checkAccountIfExistError,
    fetchRecommendedProductsError: state.manageSubs.fetchRecommendedProductsError,
    searchSubstituteProductsError: state.manageSubs.searchSubstituteProductsError,
    removeDropOutsError: state.manageSubs.removeDropOutsError,
    removeAllocatedItemError: state.manageSubs.removeAllocatedItemError,
    checkOutsLockError: state.manageSubs.checkOutsLockError,
    updateOutsRecordLockError: state.manageSubs.updateOutsRecordLockError,
    deleteManageSubsError: state.manageSubs.deleteManageSubsError,
    fetchTerritoryDataError: state.dashboard.fetchTerritoryDataError,
    fetchSearchPanelOrgInfoError: state.manageSubs.fetchSearchPanelOrgInfoError,
    fetchDropoutsDataError: state.manageSubs.fetchDropoutsDataError,
    updateEidtSubsLockError: state.manageSubs.updateEidtSubsLockError,
    updateEditAccountLockError: state.manageSubs.updateEditAccountLockError,
    validateItemInChargeError: state.manageSubs.validateItemInChargeError,
    checkEditAccountLockError: state.manageSubs.checkEditAccountLockError,
    checkEditSubsLockError: state.manageSubs.checkEditSubsLockError,
    allocateOriginalItemError: state.manageSubs.allocateOriginalItemError,
    fetchCustomerGroupDataError: state.manageSubs.fetchCustomerGroupDataError,
    fetchValidateGroupError: state.manageSubs.fetchValidateGroupError,
    fetchGroupIdsDataError: state.manageSubs.fetchGroupIdsDataError,
    fetchCustomerDataError: state.manageSubs.fetchCustomerDataError,
    removeCustomerError: state.manageSubs.removeCustomerError,
    updateCustomerGroupError: state.manageSubs.updateCustomerGroupError,
    addCustomersError: state.manageSubs.addCustomersError,
    fetchDropOutsReasonError: state.manageSubs.fetchDropOutsReasonError,
    removeCustomersError: state.manageSubs.removeCustomersError,
    fetchSubsAuditTrailDataError: state.manageSubs.fetchSubsAuditTrailDataError,
    fetchAccountsAuditTrailDataError: state.manageSubs.fetchAccountsAuditTrailDataError,
    exportManageAccountAuditTrailError: state.manageSubs.exportManageAccountAuditTrailError,
    exportSubsAuditTrailError: state.manageSubs.exportSubsAuditTrailError,
    fetchGroupsAuditTrailDataError: state.manageSubs.fetchGroupsAuditTrailDataError,
    fetchConceptIdsDataError: state.dashboard.fetchConceptIdsDataError,
    exportGroupsAuditTrailError: state.manageSubs.exportGroupsAuditTrailError,
    getSubstitutionsDataError: state.manageSubs.getSubstitutionsDataError,
    fetchOgmSubsDataError: state.manageSubs.fetchOgmSubsDataError,
  }));
  const isInIframe = window.self !== window.top; /*COT-10460 */

  // Check orientation on mount and on resize/orientation change
  // Only block mobile phones in landscape, not tablets or desktops
  useEffect(() => {
    const checkOrientationAndFold = () => {
      // Use matchMedia for reliable orientation detection (unaffected by keyboard)
      const isLandscapeMedia = window.matchMedia('(orientation: landscape)').matches;
      
      // Use screen dimensions instead of window dimensions to avoid keyboard issues
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const shortSide = Math.min(screenWidth, screenHeight);
      const longSide = Math.max(screenWidth, screenHeight);

      // UA-based phone detection (exclude tablets/iPad/laptops)
      const uaRaw = (navigator.userAgent || navigator.vendor || '');
      const uaOpera = (typeof window !== 'undefined' && window.opera) ? ' opera' : '';
      const ua = (uaRaw + uaOpera).toLowerCase();
      const isPhoneUA = /android.+mobile|iphone|ipod|windows phone|blackberry|bb10|mobi/.test(ua) &&
                        !/ipad|ipad os|tablet/.test(ua);

      // Viewport-based phone heuristic - use screen dimensions
      const isPhoneViewport = shortSide <= 600;

      const isPhone = isPhoneUA && isPhoneViewport;

      // Set mobile device state (persists across orientation changes)
      setIsMobileDevice(isPhone);

      // Guard: only block for mobile phones
      if (!isPhone) {
        setIsLandscape(false);
        return;
      }

      // Use matchMedia result for landscape detection (ignores keyboard)
      setIsLandscape(isLandscapeMedia);
    };

    checkOrientationAndFold();

    // Use matchMedia listener for orientation changes
    const orientationMediaQuery = window.matchMedia('(orientation: landscape)');
    const handleOrientationChange = (e) => {
      checkOrientationAndFold();
    };

    // Modern browsers
    if (orientationMediaQuery.addEventListener) {
      orientationMediaQuery.addEventListener('change', handleOrientationChange);
    } else {
      // Legacy browsers
      orientationMediaQuery.addListener(handleOrientationChange);
    }

    // Listen to orientationchange event (fires when device is physically rotated)
    window.addEventListener('orientationchange', checkOrientationAndFold);

    // Optional: Listen to screen orientation API if available
    if (window.screen && window.screen.orientation) {
      window.screen.orientation.addEventListener('change', checkOrientationAndFold);
    }

    return () => {
      if (orientationMediaQuery.removeEventListener) {
        orientationMediaQuery.removeEventListener('change', handleOrientationChange);
      } else {
        orientationMediaQuery.removeListener(handleOrientationChange);
      }
      
      window.removeEventListener('orientationchange', checkOrientationAndFold);
      
      if (window.screen && window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', checkOrientationAndFold);
      }
    };
  }, []);

  // Simple: when landscape modal is shown, add a body class to hide mobile layout
  useEffect(() => {
    const cls = 'orientation-blocking';
    if (isLandscape) {
      document.body.classList.add(cls);
      // Also ensure any ManageSubs mobile drawer is closed
      setCollapse(false);
    } else {
      document.body.classList.remove(cls);
    }
    return () => {
      document.body.classList.remove(cls);
    };
  }, [isLandscape]);

  const isErrorPage = fetchSubstitutionsDataError || fetchAccountDataError;
  if (fetchSubstitutionsDataError === AUTH_ERROR_MSG ||
    fetchValidationItemDataError === AUTH_ERROR_MSG ||
    fetchValidationCustomerDataError === AUTH_ERROR_MSG ||
    fetchConceptDataError === AUTH_ERROR_MSG ||
    updateSubstitutionsDataError === AUTH_ERROR_MSG ||
    fetchAddedSubsDataError === AUTH_ERROR_MSG ||
    fetchAccountDataError === AUTH_ERROR_MSG ||
    updateAccountDataError === AUTH_ERROR_MSG ||
    deleteAccountDataError === AUTH_ERROR_MSG ||
    fetchOutsDataError === AUTH_ERROR_MSG|| 
    fetchOrderDetailDataError === AUTH_ERROR_MSG ||
    fetchInventoryDataError === AUTH_ERROR_MSG|| 
    checkAccountIfExistError === AUTH_ERROR_MSG|| 
    fetchRecommendedProductsError === AUTH_ERROR_MSG|| 
    searchSubstituteProductsError === AUTH_ERROR_MSG|| 
    removeDropOutsError === AUTH_ERROR_MSG|| 
    removeAllocatedItemError === AUTH_ERROR_MSG||
    checkOutsLockError === AUTH_ERROR_MSG|| 
    updateOutsRecordLockError === AUTH_ERROR_MSG|| 
    deleteManageSubsError === AUTH_ERROR_MSG||
    fetchTerritoryDataError === AUTH_ERROR_MSG ||
    fetchSearchPanelOrgInfoError === AUTH_ERROR_MSG || 
    fetchDropoutsDataError === AUTH_ERROR_MSG ||  
    updateEidtSubsLockError === AUTH_ERROR_MSG || 
    updateEditAccountLockError === AUTH_ERROR_MSG || 
    validateItemInChargeError === AUTH_ERROR_MSG || 
    checkEditAccountLockError === AUTH_ERROR_MSG || 
    checkEditSubsLockError === AUTH_ERROR_MSG || 
    allocateOriginalItemError === AUTH_ERROR_MSG ||
    fetchCustomerGroupDataError === AUTH_ERROR_MSG || 
    fetchValidateGroupError === AUTH_ERROR_MSG ||
    fetchGroupIdsDataError === AUTH_ERROR_MSG || 
    fetchCustomerDataError === AUTH_ERROR_MSG ||
    removeCustomerError === AUTH_ERROR_MSG || 
    updateCustomerGroupError === AUTH_ERROR_MSG || 
    addCustomersError === AUTH_ERROR_MSG || 
    fetchDropOutsReasonError === AUTH_ERROR_MSG || 
    removeCustomersError === AUTH_ERROR_MSG ||
    fetchSubsAuditTrailDataError === AUTH_ERROR_MSG || 
    fetchAccountsAuditTrailDataError === AUTH_ERROR_MSG ||
    exportManageAccountAuditTrailError === AUTH_ERROR_MSG ||  
    exportSubsAuditTrailError === AUTH_ERROR_MSG ||
    fetchGroupsAuditTrailDataError === AUTH_ERROR_MSG ||
    fetchConceptIdsDataError === AUTH_ERROR_MSG ||
    exportGroupsAuditTrailError === AUTH_ERROR_MSG ||
    getSubstitutionsDataError === AUTH_ERROR_MSG || 
    fetchOgmSubsDataError === AUTH_ERROR_MSG
  ) {
    window.location.assign(redirectUrl);
  } else if (isErrorPage) {
    return <ErrorPage />;
  }

  const handleCollapse = () => {
    setCollapse((prevState) => (!prevState));
  };

  const handleDrawerClose = () => {
    setCollapse(false);
  };

  // Use isMobileDevice OR isMobile for rendering decisions
  const shouldShowMobileView = isMobileDevice || isMobile;

  return (
    <div className="manage-subs-manage-subs">
      {/* Landscape Mode Blocking Overlay */}
      {!isInIframe && ( /*COT-10460 */
        <Modal
          visible={isLandscape}
          closable={false}
          footer={null}
          centered
          maskClosable={false}
          keyboard={false}
          className="orientation-modal"
          width={300}
          mask={true}
          maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.95)' }}
        >
          <div style={{ textAlign: 'center', padding: '20px 10px' }}>
            <h3 style={{ marginBottom: '15px', fontSize: '18px' }}>Rotate to Portrait</h3>
            <p style={{ fontSize: '14px', color: '#666' }}>
              This website is optimized for Portrait mode. Please rotate your device to continue.
            </p>
          </div>
        </Modal>
      )}
      <Layout>
        {/* Desktop Navigation - Only show when not mobile */}
        {!shouldShowMobileView && (
          <Layout.Sider width={collapse ? "0" : "180"} theme="light" className="manage-subs-menu">
            <ManageSubsNavigation />
          </Layout.Sider>
        )}

        {/* Mobile Navigation - Drawer overlay */}
        {shouldShowMobileView && (
          <Drawer
            placement="left"
            onClose={handleDrawerClose}
            visible={collapse}
            bodyStyle={{ padding: 0 }}
            width={180}
            style={{
              marginTop: (window.innerWidth === 768 && window.innerHeight === 1024) ? '120px' :
                        (window.innerWidth === 800 && window.innerHeight === 1280) ? '130px' :
                        '70px'
            }}
            closable={false}
            zIndex={100}
            className="mobile-navigation-drawer"
          >
            <div className="mobile-drawer-content" style={{
              // height: '100%',
              minHeight: '100%',
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: '#E8E8E8',
            }}>
              <ManageSubsNavigationMobile />
              <div className="mobile-truck-image-container" style={{
                padding: '0px',
                textAlign: 'center',
                backgroundColor: '#E8E8E8',
              }}>
                <img src={SyscoTruck}
                  alt="Sysco Truck"
                  className="mobile-truck-image"
                  style={{ width: '100%', height: 'auto' }}
                />
              </div>
            </div>
          </Drawer>
        )}

        {/* Collapse Button Container - Desktop only */}
        {!shouldShowMobileView && (
          <div style={{ position: 'relative', width: collapse ? "10px" : "0px" }}>
            <Button style={{ width: collapse ? "10px" : "0px" }} className='collapse-btn2' disabled></Button>
            <Button 
              style={{ transform: collapse ? 'translateX(0%)' : 'translateX(-50%)' }} 
              className='collapse-btn' 
              onClick={handleCollapse}
            >
              {collapse ? (<span style={{ fontWeight: '900' }}>&gt;</span>) : (<span style={{ fontWeight: '900' }}>&lt;</span>)}
            </Button>
          </div>
        )}

        {/* Mobile Collapse Button - Fixed position */}
        {shouldShowMobileView && (
          <Button className='collapse-btn mobile-collapse-btn' onClick={handleCollapse}>
            {collapse ? (
              <span style={{ fontWeight: '900' }}>&lt;</span>
            ) : (
              <span style={{ fontWeight: '900' }}>&gt;</span>
            )}
          </Button>
        )}

        <div className={
          shouldShowMobileView ? "subs-layout-content mobile-layout-content" :
            (collapse ? "subs-layout-content collapsed-menu-content" : "subs-layout-content")
        }>
          {children}
        </div>
      </Layout>
    </div>
  );
}
